/// <reference path="../types/index.d.ts" />

import '../client_forms/boldamerican3/style.css';
import FormStructure from './boldamerican3/form_structure';

export default FormStructure;